module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uzpynFK6Vo38YHWpUbZEfK6"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH"
  }, [_vm._v("I owe a very special round of gratitude to:")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Eileen O’Callaghan, my loving and supportive wife, who shares life in so many wonderful ways, Kelliann Green, for her ongoing encouragement and support, Stephen Ohayon, Ph.D., a true gentleman, who inspired me tirelessly from the conception of my writing career, Noreen Nolan Patrone, who kept me on track, Matt Bialer, a trusted friend, Dick Marek, a man from whom I’ve learned much, and my dear friends Christine Charles, Marla Feder, Kathy Lord Nicolosi and Priscilla Winkler who listened, considered and advised.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Phil Adaszewski, NYPD, Margaret Timlin Johnsen, NYPD, (retired), and Doctor Susan Sachs, DACM, FASEMIP, L.Ac for their expert technical advice and skillful guidance.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("And to my loving granddaughter, Kristin, who calls me PaPa and watches me melt.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5713f19c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Acknowledgments.vue
// module id = 75
// module chunks = 0